import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'

export default class TimeCardsDescriptionStrategy extends DescriptionStrategy {
    constructor({ reportUrl = '' }) {
        super()
        this.params = { reportUrl }
    }

    getHeader() {
        return messageResource.getMessage('report.time_cards.title')
    }

    getDescription() {
        const firstParagraph = messageResource.getEscapedMessage('dashboard.description.time_cards.part1')
        const secondParagraph = messageResource.getEscapedMessage('dashboard.description.time_cards.part2')
        const thirdParagraph = messageResource.getEscapedMessage('dashboard.description.time_cards.part3')
        return '<div>' +
               '  <div class="firstParagraph workStatusesDescriptionColor">' + firstParagraph + '</div>' +
               '  <div class="secondParagraph">' + secondParagraph + '</div>' +
               '  <div class="thirdParagraph">' + thirdParagraph + '</div>' +
               '</div>'
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }

    getDetailsCallback() {
        openUserGuidePage('reporting#report-time-cards')
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/TimeCardsDescriptionStrategy.js